import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

// Utils
import { getElementId } from '../../common/elements/utils/elementPropertyUtils';
import inboxCanDrop from '../inbox/inboxCanDrop';
import { getHighestScore } from '../../common/elements/utils/elementLocationUtils';
import { createElementAsync } from '../element/actions/elementActions';

// Components
import FavouriteBoardSidebarItem from './FavouriteBoardSidebarItem';
import List from '../list/List';
import Button from '../components/buttons/Button';
import Icon from '../components/icons/Icon';

// Types
import { GeneralWorkspaceProps } from '../workspace/workspaceTypes';

// Constants
import { ELEMENT_CREATION_SOURCES } from '../../common/elements/elementConstants';
import { ElementType } from '../../common/elements/elementTypes';
import { BoardSections } from '../../common/boards/boardConstants';
import { ImMNElement } from '../../common/elements/elementModelTypes';

// Styles
import './SidebarTop.scss';

type SidebarTopProps = GeneralWorkspaceProps & {
    currentUserFavoriteBoardsRootId: string;
    sideBarElements: Immutable.List<ImMNElement>;
};

const SidebarTop = (props: SidebarTopProps): ReactElement => {
    const dispatch = useDispatch();

    const { currentUserFavoriteBoardsRootId, sideBarElements } = props;

    const dispatchCreateNewFavouriteBoard = () => {
        const highestScore = getHighestScore(sideBarElements?.toJS());

        dispatch(
            createElementAsync({
                creationSource: ELEMENT_CREATION_SOURCES.SIDEBAR,
                elementType: ElementType.BOARD_TYPE,
                location: {
                    parentId: currentUserFavoriteBoardsRootId,
                    section: BoardSections.INBOX,
                    position: {
                        score: highestScore + 1,
                    },
                },
                content: {
                    title: 'New Folder',
                },
            }),
        );
    };

    return (
        <div className="SidebarTop">
            <h4>Your boards</h4>

            <List
                listCanDropFn={inboxCanDrop}
                {...props}
                listId={currentUserFavoriteBoardsRootId}
                childElementIds={sideBarElements.map((element) => getElementId(element)).toArray()}
                listElementProps={{
                    ElementComponent: FavouriteBoardSidebarItem,
                    ...props,
                    currentUserFavoriteBoardsRootId,
                }}
            ></List>

            <Button className="AddBoardButton" onClickFn={dispatchCreateNewFavouriteBoard}>
                <div className="button-content">
                    <Icon name="plus" />
                    <div className="title">Create new</div>
                </div>
            </Button>
        </div>
    );
};

export default SidebarTop;
